import { Expose } from "class-transformer";
import type { IProfileDataDto } from "./profile-data.dto.interface";

export class ProfileDataDto implements IProfileDataDto {
  @Expose()
  lastUpdatedDate?: string;

  @Expose()
  isHouseholdCompositionAsked?: boolean;

  @Expose()
  isHouseholdConfirmed?: boolean;

  @Expose()
  hasKnownIsee?: boolean;

  @Expose()
  hasDeclaredIncome?: boolean;

  @Expose()
  isIncomeConfirmed?: boolean;

  @Expose()
  isRealEstateConfirmed?: boolean;
}
